import { COMPANY } from "./actions";
import initialState from "../../../reducers/initialState";

const ComopanyReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY.SET_CURRENT_COMPANY: {
      return {
        ...state,
        currentCompany: action.currentCompany,
      };
    }

    case COMPANY.SET_CURRENT_PROJECT: {
      return {
        ...state,
        currentProject: action.currentProject,
      };
    }
    case COMPANY.SET_PROJECT_LIST: {
      return {
        ...state,
        projectList: action.projectList,
      };
    }

    default:
      return state;
  }
};

export default ComopanyReducer;
